import React from 'react'

import { Button, Col, Form, Input, Modal, Row } from 'antd'
import locale from 'antd/es/date-picker/locale/ru_RU'
import { useTranslation } from 'react-i18next'

import NumberInput from '@app/pages/reference-book-billing-page/components/number-input/number-input'
import { CustomAntdDatePicker } from '@app/shared/custom-antd-datepicker'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import { useCreatePupilManualPaymentMutation } from '@app/store/rtk/api/billing/pupil-billing'

type Props = {
  visible: boolean
  onCancel: () => void

  pupilId: number
  organizationId: number
}

export const AddPupilPaymentModal = (props: Props) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const [createPupilManualPayment, { isLoading }] =
    useCreatePupilManualPaymentMutation()

  const onSuccess = () => {
    //
  }

  const handleSubmit = async (values) => {
    try {
      const response = await createPupilManualPayment({
        calculatedAmount: +values.calculatedAmount * 100,
        paidAmount: +values.paidAmount * 100,
        workingDay: +values.workingDay,
        period: values.period.format('YYYY-MM'),
        purpose: values.purpose,

        transactionDate: values.transactionDate.format('YYYY-MM-DD'),

        organizationId: props.organizationId,
        pupilId: props.pupilId,
      })

      if ('data' in response) {
        if (response?.data?.status === 'ERROR') {
          openNotificationWithIcon(
            'error',
            t('pupils.billing.failedCreatePayment'),
          )
        } else {
          onSuccess()
          form.resetFields()
          props.onCancel()
        }
      } else {
        throw new Error()
      }
    } catch (error) {
      console.log(error)
      openNotificationWithIcon('error', t('pupils.billing.failedCreatePayment'))
    }
  }

  return (
    <Modal
      visible={props.visible}
      title={t('pupils.billing.addPayment')}
      onCancel={() => {
        props.onCancel()
        form.resetFields()
      }}
      footer={null}
      width={400}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          workingDay: '',
          period: '',
          // calculatedAmount: 0,
          // paidAmount: 0,
          purpose: '',
        }}>
        <Row gutter={[20, 10]} justify={'center'} style={{ marginBottom: 20 }}>
          <Col span={24}>
            <strong>{t('pupils.billing.period')}</strong>
            <Form.Item name={'period'} rules={[{ required: true }]} noStyle>
              <CustomAntdDatePicker
                picker="month"
                locale={locale}
                style={{ width: '100%' }}
                format={'YYYY-MM'}
                placeholder={'YYYY-MM'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <strong>{t('pupils.billing.transactionDate')}</strong>
            <Form.Item
              name={'transactionDate'}
              rules={[{ required: true }]}
              noStyle>
              <CustomAntdDatePicker
                locale={locale}
                style={{ width: '100%' }}
                format={'YYYY-MM-DD'}
                placeholder={'YYYY-MM-DD'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <strong>{t('pupils.billing.calculatedDays')}</strong>
            <Form.Item name={'workingDay'} rules={[{ required: true }]} noStyle>
              <NumberInput
                placeholder={t('pupils.billing.calculatedDays')}
                thousandSeparator=""
                decimalScale={0}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <strong>{t('pupils.billing.calculatedAmount')}</strong>
            <Form.Item
              name={'calculatedAmount'}
              rules={[{ required: true }]}
              noStyle>
              <NumberInput placeholder={t('pupils.billing.calculatedAmount')} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <strong>{t('pupils.billing.paymentAmount')}</strong>
            <Form.Item name={'paidAmount'} rules={[{ required: true }]} noStyle>
              <NumberInput placeholder={t('pupils.billing.paymentAmount')} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <strong>{t('pupils.billing.paymentPurpose')}</strong>
            <Form.Item name={'purpose'} rules={[{ required: true }]} noStyle>
              <Input placeholder={t('pupils.billing.paymentPurpose')} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item className="text-right">
          <Button onClick={props.onCancel} style={{ marginRight: 8 }}>
            {t('general.cancel')}
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {t('general.add')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}
